module.exports = __webpack_public_path__ + "static/material-badge-position-fdf24b861cd1510ad1255b037e53b556.gif";